import React, { FC, Ref } from 'react';
import clsx from 'clsx';
import { ArrowLeft } from 'components/icons';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
import { desktop } from 'helpers/utils/screensizes';

export type SliderNavigationProps = {
  arrows?: boolean;
  navigationPrevRef?: Ref<HTMLButtonElement>;
  navigationNextRef?: Ref<HTMLButtonElement>;
  blackBG?: boolean;
};

const CondensedSliderNavigation: FC<SliderNavigationProps> = ({
  arrows,
  navigationPrevRef,
  navigationNextRef,
  blackBG = false,
}) => {
  const arrowsClassName = clsx([arrows ? 'block' : 'hidden'], 'z-10');
  const [isDesktopSize] = useMediaQuery(desktop);
  const bgClass = blackBG ? 'inline-flex items-center justify-center rounded-[50%] bg-black p-2' : '';
  return (
    <div className={arrowsClassName} data-ffid="ctr-slider-condensed">
      <button
        ref={navigationPrevRef}
        type="button"
        className={`absolute ${isDesktopSize ? 'top-0' : 'top-2'} left-0 cursor-pointer border-0 bg-transparent p-0 focus:outline-none focus-visible:ring-2 focus-visible:ring-white`}
        aria-label="Previous slide"
        data-ffid="btn-prev-condensed"
      >
        <span className={bgClass}>
          <ArrowLeft
            className="text-white"
            dimension={isDesktopSize ? 24 : 16}
            aria-hidden="true"
            data-ffid="icon-prev-condensed"
          />
        </span>
      </button>

      <button
        ref={navigationNextRef}
        type="button"
        className={`absolute ${isDesktopSize ? 'top-0' : 'top-2'} right-0 cursor-pointer border-0 bg-transparent p-0 focus:outline-none focus-visible:ring-2 focus-visible:ring-white`}
        aria-label="Next slide"
        data-ffid="btn-next-condensed"
      >
        <span className={bgClass}>
          <ArrowLeft
            className="rotate-180 text-white"
            dimension={isDesktopSize ? 24 : 16}
            aria-hidden="true"
            data-ffid="icon-next-condensed"
          />
        </span>
      </button>
    </div>
  );
};

export default CondensedSliderNavigation;
